/**
 * `localStorage` da aba Solicitações. Todo acesso é embrulhado: modo privado, política
 * corporativa ou cota cheia fazem `localStorage` LANÇAR, e a aba não pode deixar de
 * carregar por causa de uma conveniência (mesma regra de `no-schedule-expected-preference`).
 */

const USER_ID_KEY = '@ME:userId'

/** Id do usuário logado para qualificar a chave; `anon` quando não há (máquina compartilhada). */
export function currentUserStorageId(): string {
  try {
    const id = localStorage.getItem(USER_ID_KEY)
    return id && id.trim() ? id.trim() : 'anon'
  } catch {
    return 'anon'
  }
}

/** JSON lido da chave; `null` quando ausente, inválido ou inacessível. */
export function readStorageJson(key: string): unknown {
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as unknown) : null
  } catch {
    return null
  }
}

export function writeStorageJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Conveniência: sem persistência a aba continua funcionando na sessão.
  }
}
